import script from "./WatchlistOrderItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchlistOrderItem.vue?vue&type=script&setup=true&lang=ts"

import "./WatchlistOrderItem.vue?vue&type=style&index=0&id=2d0b3344&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d0b3344"]])

export default __exports__